import { Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  '&.MuiToolbar-root': {
    minHeight: 48,
    height: 48,
    padding: theme.spacing(0.5, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0.5, 3, 0.5, 2),
    },
  },
}));
